import React from 'react';
import '../Loader.css'; 

const Loader = ({ progress }) => {
  return (
    <div className="loader-container">
      <div
        className="loader"
        style={{ width: `${progress}%` }} 
      ></div>
    </div>
  );
};

export default Loader;
